import { render, staticRenderFns } from "./farmersummary_details.vue?vue&type=template&id=63f4a27e"
import script from "./farmersummary_details.vue?vue&type=script&lang=js"
export * from "./farmersummary_details.vue?vue&type=script&lang=js"
import style0 from "./farmersummary_details.vue?vue&type=style&index=0&id=63f4a27e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports